import React from 'react'
import { Progress } from '@chakra-ui/react'

export default (props) => {
  return (
    <Progress.Root size='xs' variant='subtle' colorPalette='primary' w={props.w} value={props.value}>
      <Progress.Track>
        <Progress.Range />
      </Progress.Track>
    </Progress.Root>
  )
}
